export enum AccountType {
  Customer = 2
}